import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { TextButtonComponent } from '@@shared/design/components/text-button/text-button.component';


@Component({
	selector: 'sl-generic-dialog',
	templateUrl: './generic-dialog.component.html',
	styleUrl: './generic-dialog.component.scss',
	standalone: true,
	imports: [
		MatDialogTitle,
		MatDialogContent,
		MatDialogActions,
		MatDialogClose,
		TextButtonComponent
	]
})
export class GenericDialogComponent {
	readonly title: SafeHtml = inject(DomSanitizer).bypassSecurityTrustHtml(inject(MAT_DIALOG_DATA)?.title);
	readonly content: SafeHtml = inject(DomSanitizer).bypassSecurityTrustHtml(inject(MAT_DIALOG_DATA)?.content);
}
